import { locationService } from '../_services';

export const location = {
    namespaced: true,
    state: {
        all: [],
        ready: false
    },
    actions: {
        getLocationCollection({ commit }) {
            commit('getAllRequest');
            return new Promise((resolve, reject) => {
                locationService.getLocationCollection()
                .then(
                    status => {
                        commit('getAllSuccess', status);
                        resolve(status);
                    },
                    error => {
                        commit('getAllFailure', error);
                        reject(error);
                    }
                );})
        },
        getLocationItem({ commit },{id}) {
            commit('getAllRequest');
            return new Promise((resolve, reject) => {
                locationService.getLocationItem(id)
                    .then(
                        status => {
                            commit('getAllSuccess', status);
                            resolve(status);
                        },
                        error => {
                            commit('getAllFailure', error);
                            reject(error);
                        }
                    );})
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.ready = false;
        },
        getAllSuccess(state, status) {
            state.all = status['hydra:member'];
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.ready = false;
        }
    },
    getters: {
        showLocationCollection(state) {
            return state.all;
        },
        showLocationByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        showLocationByCustomer(state) {
            return iri => {
                return state.all.find(obj => obj.customer['@id'] === iri)
            }
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
